import { useState } from "react";

import DestinatariosCard from "./components/DestinatariosCard";
import MensajeCard from "./components/MensajeCard";
import AdjuntosCard from "./components/AdjuntosCard";
import PreviewCard from "./components/PreviewCard";
import HistorialTab from "./components/HistorialTab";
import PlantillasTab from "./components/PlantillasTab";
import {
  sendCampaign,
  sendCampaignWithAttachments,
} from "./services/campaignApi";

import "./CampanasMail.css";

export default function CampanasMail() {
  const [activeTab, setActiveTab] = useState("campaign");

  const [campaign, setCampaign] = useState({
    subject: "",
    body: "",

    recipientMode: "all", // all | psychology | speech | nutrition | manual

    recipients: [],

    attachments: [],

    sendCopy: true,
  });

  const [sending, setSending] = useState(false);

  const [sendResult, setSendResult] = useState(null);

  const [sendError, setSendError] = useState("");

  function validateCampaign() {
    if (!campaign.subject.trim()) {
      return "Escribe un asunto.";
    }

    if (!campaign.body.trim()) {
      return "Escribe un mensaje.";
    }

    if (
      campaign.recipientMode === "manual" &&
      campaign.recipients.length === 0
    ) {
      return "Selecciona al menos un destinatario.";
    }

    return null;
  }

  async function handleSendCampaign() {
    const error = validateCampaign();

    if (error) {
      alert(error);
      return;
    }

    const total =
      campaign.recipientMode === "manual" ? campaign.recipients.length : null;

    if (
      !window.confirm(
        total
          ? `¿Enviar la campaña a ${total} destinatarios?`
          : "¿Enviar la campaña?",
      )
    ) {
      return;
    }

    try {
      setSending(true);
      setSendError("");
      setSendResult(null);

      let response;

      if (campaign.attachments && campaign.attachments.length > 0) {
        response = await sendCampaignWithAttachments(campaign);
      } else {
        response = await sendCampaign(campaign);
      }

      setSendResult(response);

      alert(
        `Campaña enviada correctamente.\n\nEnviados: ${response.sent}\nFallidos: ${response.failed}`,
      );

      setCampaign({
        subject: "",
        body: "",

        recipientMode: "all",

        recipients: [],

        attachments: [],

        sendCopy: true,
      });

      setActiveTab("history");
    } catch (e) {
      console.error(e);

      setSendError(e.message || "No se pudo enviar la campaña.");
    } finally {
      setSending(false);
    }
  }

  return (
    <div className="campaign-page">
      <div className="campaign-header">
        <div>
          <h1>📧 Comunicaciones</h1>
          <p>Envía campañas de correo a pacientes y familias del centro.</p>
        </div>
      </div>

      <div className="campaign-tabs">
        <button
          className={activeTab === "campaign" ? "active" : ""}
          onClick={() => setActiveTab("campaign")}
        >
          <i className="fa-solid fa-paper-plane" />
          Nueva campaña
        </button>

        <button
          className={activeTab === "history" ? "active" : ""}
          onClick={() => setActiveTab("history")}
        >
          <i className="fa-solid fa-clock-rotate-left" />
          Historial
        </button>

        <button
          className={activeTab === "templates" ? "active" : ""}
          onClick={() => setActiveTab("templates")}
        >
          <i className="fa-solid fa-file-lines" />
          Plantillas
        </button>
      </div>

      {activeTab === "campaign" && (
        <div className="campaign-grid">
          <DestinatariosCard campaign={campaign} setCampaign={setCampaign} />

          <MensajeCard campaign={campaign} setCampaign={setCampaign} />

          <AdjuntosCard campaign={campaign} setCampaign={setCampaign} />

          <PreviewCard campaign={campaign} />

          <div className="campaign-actions">
            <div className="campaign-status">
              {sendError && (
                <div className="campaign-error">
                  <i className="fa-solid fa-circle-exclamation" />

                  {sendError}
                </div>
              )}

              {sendResult && (
                <div className="campaign-success">
                  <i className="fa-solid fa-circle-check" />
                  Campaña enviada correctamente.
                  <strong> {sendResult.sent}</strong> enviados.
                  {sendResult.failed > 0 && (
                    <>
                      {" "}
                      <strong>{sendResult.failed}</strong> fallidos.
                    </>
                  )}
                </div>
              )}
            </div>

            <button
              className="campaign-send-button"
              disabled={sending}
              onClick={handleSendCampaign}
            >
              {sending ? (
                <>
                  <i className="fa-solid fa-spinner fa-spin" />
                  Enviando...
                </>
              ) : (
                <>
                  <i className="fa-solid fa-paper-plane" />
                  Enviar campaña
                </>
              )}
            </button>
          </div>
        </div>
      )}

      {activeTab === "history" && <HistorialTab />}

      {activeTab === "templates" && <PlantillasTab />}
    </div>
  );
}
